import { useQuery } from '@apollo/client';

import {
  GQLDExperiment,
  GQLLayoutContent,
  GQLLayoutContentgbxOrganicUpgradePageArgs,
  GQLMyData,
  GQLQuery,
} from '../../../../../gql.generated';
import { CmsTextAsset } from '../../../../../utils/types';
import { GET_ORGANIC_CHECKOUT_PAGE } from '../../queries/GET_ORGANIC_PAGES';

export interface ExtendedLayout extends GQLLayoutContent {
  subscriptionCheckoutAsset: GQLLayoutContent['vcmsAsset'];
  gbxMetaTitle?: CmsTextAsset;
  gbxMetaDescription?: CmsTextAsset;
}

export interface ExtendedMyData extends GQLMyData {
  layout: ExtendedLayout;
}

export interface ExtendedQuery extends GQLQuery {
  me: ExtendedMyData;
}

interface ExtendedProps extends GQLLayoutContentgbxOrganicUpgradePageArgs {
  subscriptionCheckoutCmsIdentifier: string;
}

const useGetOrganicCheckoutPage = (
  dExperiment?: GQLDExperiment,
  subscriptionCheckoutCmsIdentifier = 'ADD_GBX'
) => {
  return useQuery<ExtendedQuery, ExtendedProps>(GET_ORGANIC_CHECKOUT_PAGE, {
    variables: {
      dExperiment,
      subscriptionCheckoutCmsIdentifier,
    },
  });
};
export default useGetOrganicCheckoutPage;
